export const getIsPosting = state => state.getIn(['creatCase', 'isPosting']);
export const getIsChecking = state => state.getIn(['creatCase', 'isChecking']);
export const getErrMsg = state => state.getIn(['creatCase', 'errMsg']);

export const getCaseRelateList = state => state.getIn(['creatCase', 'caseRelateList']);
export const getIsFetching = state => state.getIn(['creatCase', 'isFetching']);
export const getCustodianConflict = state => state.getIn(['creatCase', 'custodianConflict']);